











import Vue from "vue";
import LatestNews from "@/components/organisms/LatestNews.vue";
import RelatedServices from "@/components/organisms/RelatedServices.vue";
import ContestNotification from "@/components/organisms/ContestNotification.vue";
import NovelList from "@/components/organisms/NovelList.vue";
import { showNotifyDialog } from "@/lib/dialog";
import { isTwitterLogin } from "@/lib/twitterAuth";
import { Auth } from "aws-amplify";
import { checkDeprecatedBrowser } from "@/lib/checkDeprecatedBrowser";
import isMobile from "ismobilejs";
import { format } from "date-fns";
import axiosBase from "axios";
const axios = axiosBase.create({
  baseURL: process.env.VUE_APP_MICROCMS_API_ENDPOINT,
  headers: { "X-API-KEY": process.env.VUE_APP_MICROCMS_API_KEY },
});

export default Vue.extend({
  components: {
    LatestNews,
    RelatedServices,
    ContestNotification,
    NovelList,
  },
  data() {
    return {
      username: <string | null>null,
      banner: null,
      news: null,
      contests: [],
      checkedTwitterLogin: false,
    };
  },
  computed: {
    novels() {
      return this.$store.getters["novelModule/novels"];
    },
    isPC() {
      return !isMobile().any;
    },
  },
  methods: {
    async checkTwitterLogin() {
      if (
        isTwitterLogin() &&
        (!this.novels || !this.novels.length) &&
        sessionStorage.getItem("TESTING") === undefined
      ) {
        if (
          confirm(
            "Twitterログインは新規ユーザーは利用できません。\nメールアドレスで会員登録、ログインしてください。\n\nログアウトしますか？"
          )
        ) {
          await Auth.signOut();
          window.localStorage.clear();
          // alert('Twitterログインは新規ユーザーは利用できません。\nメールアドレスで会員登録、ログインしてください。');
          location.href = "/lp";
        }
      }
    },
  },
  async created() {
    const { $store, isPC } = this;

    /** 非推奨ブラウザへの文言表示 */
    checkDeprecatedBrowser();

    $store.dispatch("novelModule/initialize");
    $store.dispatch("manuscriptModule/initializeGeneralSettings");
    $store.dispatch("novelModule/initializeManuscriptSettings");

    const bannerRequest = await axios.get(`/bannerweb?limit=${isPC ? 2 : 1}`);
    const newsRequest = await axios.get(`/news?limit=${isPC ? 3 : 2}`);
    if (bannerRequest.status !== 200 || newsRequest.status !== 200) {
      await showNotifyDialog({
        title: "エラー",
        content: "お知らせの取得に失敗しました。",
      });
    }
    this.banner = bannerRequest.data.contents;
    this.news = newsRequest.data.contents;

    const currentDate = format(new Date(), "YYYY-MM-DD");

    const contestRequest = await axios.get(`/contest?filters=deadline[greater_than]${currentDate}&limit=1`);
    if (contestRequest.status !== 200) {
      await showNotifyDialog({
        title: "エラー",
        content: "コンテスト情報の取得に失敗しました。",
      });
    }
    this.contests = contestRequest.data.contents;
  },
  watch: {
    novels() {
      if (!this.checkedTwitterLogin) {
        this.checkTwitterLogin();
        this.checkedTwitterLogin = true;
      }
    },
  },
});
